// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

// import th from '../locales/th_TH';
// import en from '../locales/en_US';

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    // lang: {
    //     locales: { en, th },
    //     current: 'th'
    // }
})
